import React from "react";

function InlineAlert(props) {
  const { alertMessage, alertType, children } = props;
  const alertStyle = `u--paddingSmall-bottom alert-inline alert-inline--${alertType}`;

  const alertIcon = `mw-icon-${alertType} u__margin--right-sm`;
  return (
    <div className={alertStyle}>
      {alertType === "info" && <span className={alertIcon} />}
      <span className="alert-inline__message">
        {alertMessage || children}
      </span>
    </div>
  );
}

InlineAlert.defaultProps = {
  children: null,
  onClick: () => null
}

export default InlineAlert;